// @ts-nocheck
/**
 * GA4 Profile & Cart Events
 * ClickProfileIcon - profile icon click in nav
 * ClickCartIcon - cart icon click
 * SysCartModalDisplayed - when cart drawer/modal is displayed
 * ClickBuyNowOnCartModal - Shiprocket BUY NOW button in cart drawer
 */

(function () {
  const gtag = window.trovelle?.ga4?.gtag;
  const measurementId = window.trovelle?.ga4?.measurementId;
  if (!gtag || !measurementId) return;

  function getPageParams() {
    const route = window.trovelle?.ga4?.route?.getRoute?.();
    const pt = route?.pageType || 'page';
    const pageType = pt.charAt(0).toUpperCase() + pt.slice(1);
    return {
      page_location: window.location.href,
      page_title: document.title || '',
      referrer: document.referrer || '',
      page_type: pageType,
    };
  }

  function fireClickProfileIcon() {
    gtag('event', 'ClickProfileIcon', getPageParams());
  }

  async function fetchCart() {
    try {
      const root = (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
      const url = root + 'cart.js';
      const res = await fetch(url);
      if (!res.ok) return null;
      return await res.json();
    } catch {
      return null;
    }
  }

  function getCollectionNameFromPage() {
    return (
      document.querySelector('.product-information[data-ga4-collection-name]')?.getAttribute('data-ga4-collection-name') ||
      document.querySelector('[data-collection-name]')?.getAttribute('data-collection-name') ||
      ''
    );
  }

  function extractLineItemProp(item, key) {
    const props = item?.properties;
    if (!props) return '';
    if (typeof props === 'object' && props[key] != null) return String(props[key]);
    const k = String(key).toLowerCase();
    const matchKey = Object.keys(props).find((x) => String(x).toLowerCase() === k);
    return matchKey ? String(props[matchKey] ?? '') : '';
  }

  function buildCartParams(cart) {
    const base = getPageParams();
    if (!cart) return base;

    const parsePrice = (val) => {
      const n = typeof val === 'string' ? parseFloat(val) : Number(val);
      return isNaN(n) ? 0 : n;
    };

    const totalPrice = parsePrice(cart.total_price);
    const totalDiscount = parsePrice(cart.total_discount);
    const cartValue = totalPrice / 100;
    const discountAmount = totalDiscount / 100;

    const discountCodes = cart.discount_codes || [];
    const discountCode = discountCodes.length > 0 ? discountCodes.map((d) => d.code).join(', ') : '';

    const cartItems = (cart.items || []).map((item) => {
      const color =
        extractLineItemProp(item, 'color') ||
        extractLineItemProp(item, 'Color') ||
        item.variant_options?.[0] ||
        '';
      const fit = extractLineItemProp(item, 'fit') || extractLineItemProp(item, 'Fit') || '';
      const composition =
        extractLineItemProp(item, 'composition') ||
        extractLineItemProp(item, 'Composition') ||
        extractLineItemProp(item, 'fabric') ||
        extractLineItemProp(item, 'Fabric') ||
        '';

      return {
        product_id: item.sku || String(item.variant_id || item.id || ''),
        title: item.product_title || item.title || '',
        vendor_id: item.vendor || '',
        vendor_name: item.vendor || '',
        sku_id: item.sku || '',
        product_type: item.product_type || '',
        price: parsePrice(item.final_price ?? item.price) / 100,
        color,
        fit,
        composition,
      };
    });

    return {
      ...base,
      collection_name: getCollectionNameFromPage(),
      cart_item_quantity: cart.item_count || 0,
      cart_items: cartItems,
      cart_value: cartValue,
      discount_amount: discountAmount,
      discount_code: discountCode,
    };
  }

  function fireClickCartIcon(params) {
    gtag('event', 'ClickCartIcon', params);
  }

  function fireSysCartModalDisplayed(params) {
    gtag('event', 'SysCartModalDisplayed', params);
  }

  function fireClickXButton(params) {
    gtag('event', 'ClickXButton', params);
  }

  function fireClickDiscountApply(params) {
    gtag('event', 'ClickDiscountApply', params);
  }

  function fireClickCheckoutButton(params) {
    gtag('event', 'ClickCheckoutButton', params);
  }

  function fireClickBuyNowOnCartModal(params) {
    gtag('event', 'ClickBuyNowOnCartModal', params);
  }

  function fireClickBinButton(params) {
    gtag('event', 'ClickBinButton', params);
  }

  function getCartLineFromRemoveButton(btn) {
    if (!(btn instanceof Element)) return null;
    const attr = btn.getAttribute('on:click') || btn.getAttribute('data-on-click') || '';
    if (!attr) return null;
    const m = String(attr).match(/onLineItemRemove\/(\d+)/i);
    if (!m) return null;
    const line = parseInt(m[1], 10);
    return Number.isFinite(line) && line > 0 ? line : null;
  }

  function init() {
    document.querySelectorAll('.account-button').forEach((btn) => {
      btn.addEventListener('click', () => fireClickProfileIcon());
    });

    const cartDrawerTrigger = document.querySelector(
      'cart-drawer-component [data-testid="cart-drawer-trigger"], cart-drawer-component > button'
    );
    if (cartDrawerTrigger) {
      cartDrawerTrigger.addEventListener('click', async () => {
        const cart = await fetchCart();
        const params = buildCartParams(cart);
        fireClickCartIcon(params);
      });
    }

    const cartPageLink = document.querySelector('a.header-actions__action.action__cart');
    if (cartPageLink) {
      cartPageLink.addEventListener('click', async () => {
        const cart = await fetchCart();
        const params = buildCartParams(cart);
        fireClickCartIcon(params);
      });
    }

    const cartDrawer = document.querySelector('cart-drawer-component');
    if (cartDrawer) {
      cartDrawer.addEventListener('dialog:open', async () => {
        const cart = await fetchCart();
        const params = buildCartParams(cart);
        fireSysCartModalDisplayed(params);
      });

      cartDrawer.addEventListener('click', async (e) => {
        const target = e.target;
        if (!(target instanceof Element)) return;
        const closeBtn = target.closest('.cart-drawer__close-button');
        if (!closeBtn) return;
        const cart = await fetchCart();
        const params = buildCartParams(cart);
        fireClickXButton(params);
      });

      cartDrawer.addEventListener('click', async (e) => {
        const target = e.target;
        if (!(target instanceof Element)) return;
        const applyBtn = target.closest('.cart-discount__button');
        if (!applyBtn) return;

        const cart = await fetchCart();
        const params = buildCartParams(cart);

        const form = applyBtn.closest('form.cart-discount__form');
        const input = form?.querySelector?.('input[name="discount"]');
        if (input instanceof HTMLInputElement && input.value) {
          params.discount_code = input.value;
        }

        fireClickDiscountApply(params);
      });

      cartDrawer.addEventListener('click', async (e) => {
        const target = e.target;
        if (!(target instanceof Element)) return;
        const checkoutBtn = target.closest('.cart__checkout-button, #checkout');
        if (!checkoutBtn) return;

        const cart = await fetchCart();
        const params = buildCartParams(cart);
        fireClickCheckoutButton(params);
      });

      cartDrawer.addEventListener(
        'click',
        async (e) => {
          const target = e.target;
          if (!(target instanceof Element)) return;
          const buyNowBtn = target.closest('button.sr-headless-checkout, button[name="sr-headless-button"]');
          if (!buyNowBtn) return;

          const cart = await fetchCart();
          const params = buildCartParams(cart);
          fireClickBuyNowOnCartModal(params);
        },
        { capture: true }
      );

      cartDrawer.addEventListener('click', async (e) => {
        const target = e.target;
        if (!(target instanceof Element)) return;
        const removeBtn = target.closest('.cart-items__remove');
        if (!removeBtn) return;

        const cart = await fetchCart();
        const params = buildCartParams(cart);

        const line = getCartLineFromRemoveButton(removeBtn);
        const item = line != null ? cart?.items?.[line - 1] : null;
        if (item) {
          params.product_id = item.sku || String(item.variant_id || item.id || '');
          params.title = item.product_title || item.title || '';
        } else {
          params.product_id = '';
          params.title = '';
        }

        fireClickBinButton(params);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
